import React from "react";
import useStyles from "./style";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  Grid,
  TextField,
  Box,
} from "@mui/material";
import { AccountBalanceWalletOutlined } from "@mui/icons-material";
import { useFormik } from "formik";
import * as yup from "yup";

//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";

//Services
import AvailablebanksApi from "Services/Availablebanks";

const AddBanks = (props) => {
  const { openDialog, handleClose } = props;
  const classes = useStyles();
  const dispatch = useDispatch();

  const demoaccount_id = useSelector(
    (state) => state?.AuthReducer?.demoaccount_id || ""
  );

  const handleAddBanks = (formValues) => {
    dispatch(showLoader("Loading please wait..."));

    const data = {
      accounttype: formValues?.accounttype,
      Cashoutcode: formValues?.Cashoutcode,
      demoaccount_id: demoaccount_id || "",
    };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: res?.data?.message || "Bank Acc type added Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );
        formik.resetForm();
        handleClose();
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error while create Acc type",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    AvailablebanksApi.addBanksacc({ ...data }).then(onSuccess, onFailure);
  };

  const formik = useFormik({
    initialValues: {
      accounttype: "",
      Cashoutcode: "",
    },
    validationSchema: yup.object({
      accounttype: yup.string().required("Account type is required").nullable(),
      Cashoutcode: yup
        .number()
        .typeError("Cashoutcode must be a number")
        .required("Cashoutcode is required")
        .nullable(),
    }),
    enableReinitialize: true,
    onSubmit: handleAddBanks,
  });

  return (
    <Dialog
      open={openDialog}
      onClose={() => {
        formik.resetForm();
        handleClose();
      }}
      classes={{ paper: classes.dialogPaper }}
    >
      <Box className={classes.headerContainer}>
        <Typography className={classes.dialogTitle}>Add Account Type</Typography>
        <Typography className={classes.breadcrumb}>
          Admin / <span>Account Type Settings</span>
        </Typography>
      </Box>

      <DialogContent style={{ padding: 0 }}>
        <form onSubmit={formik.handleSubmit}>
          <Grid container spacing={3}>
            {/* Account Type */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.formLabel}>Account Type</Typography>
              <TextField
                name="accounttype"
                placeholder="e.g. Savings"
                value={formik.values.accounttype}
                onChange={formik.handleChange}
                error={formik.touched.accounttype && Boolean(formik.errors.accounttype)}
                helperText={formik.touched.accounttype && formik.errors.accounttype}
                fullWidth
                variant="outlined"
                size="small"
                className={classes.formInput}
              />
            </Grid>

            {/* Code */}
            <Grid item xs={12} md={6}>
              <Typography className={classes.formLabel}>Code</Typography>
              <TextField
                name="Cashoutcode"
                placeholder="e.g. 101"
                value={formik.values.Cashoutcode}
                onChange={formik.handleChange}
                error={formik.touched.Cashoutcode && Boolean(formik.errors.Cashoutcode)}
                helperText={formik.touched.Cashoutcode && formik.errors.Cashoutcode}
                fullWidth
                variant="outlined"
                size="small"
                className={classes.formInput}
              />
            </Grid>
          </Grid>

          <Box className={classes.dialogActions}>
            <Button
              className={classes.cancelButton}
              onClick={() => {
                formik.resetForm();
                handleClose();
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              variant="contained"
              className={classes.submitButton}
            >
              <AccountBalanceWalletOutlined style={{ fontSize: "18px" }} />
              Add Account-Type
            </Button>
          </Box>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default AddBanks;
